module.exports = __webpack_public_path__ + "img/entertainment-3.31ad959c.jpg";